const Tooltip = ({ title, description, children, active, hidden }) => {
  return (
    <>
    { !hidden && (
      <span className="tooltip-container">
        <div className={"tooltip-body" + (active ? ' active' : '')}>
          <p className="tooltip-title">{title}</p>
          <p className="tooltip-description">{description}</p>
        </div>
        <span className="tooltip-element">{children}</span>
        </span>
    )}
    </>
  );
};

export default Tooltip;